var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "homepage"
  }, [_c("section", {
    staticClass: "homepage__banner-wrapper"
  }, [_c("Banner"), _c("a-popover", {
    attrs: {
      placement: "leftBottom"
    },
    model: {
      value: _vm.popoverVisible,
      callback: function ($$v) {
        _vm.popoverVisible = $$v;
      },
      expression: "popoverVisible"
    }
  }, [_c("template", {
    slot: "content"
  }, [_c("div", {
    staticClass: "consult-content"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/customerHead.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "details"
  }, [_c("p", [_vm._v("想了解更多，欢迎拨打热线")]), _c("p", [_vm._v("0571-8891 1818")]), _c("p", [_vm._v("接通后请转接B2B-8207")]), _c("div", {
    staticClass: "appoint",
    on: {
      click: _vm.handleAppoint
    }
  }, [_vm._v("立即预约")])])])]), _c("div", {
    staticClass: "consult"
  }, [_c("span", [_vm._v("咨询")])])], 2)], 1), _c("section", {
    staticClass: "homepage__product-wrapper"
  }, [_c("Product")], 1), _c("section", {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: require("@/assets/images/homepage/ai-bg.png"),
      expression: "require('@/assets/images/homepage/ai-bg.png')",
      arg: "background-image"
    }],
    staticClass: "homepage__technology"
  }, [_c("Technology")], 1), _c("section", {
    staticClass: "homepage__solutions"
  }, [_c("Solutions")], 1), _c("section", {
    staticClass: "homepage__skill-wrapper"
  }, [_c("h4", {
    staticClass: "area puhui-M"
  }, [_vm._v("25年技术沉淀 成就行业口碑")]), _c("Skill", {
    staticClass: "area",
    attrs: {
      skillList: _vm.skillList,
      span: 6
    }
  })], 1), _c("section", {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: require("@/assets/images/homepage/customer-bg.png"),
      expression: "require('@/assets/images/homepage/customer-bg.png')",
      arg: "background-image"
    }],
    staticClass: "homepage__recommend-wrapper"
  }, [_c("Recommend")], 1), _c("section", {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: require("@/assets/images/homepage/partner_bg.png"),
      expression: "require('@/assets/images/homepage/partner_bg.png')",
      arg: "background-image"
    }],
    staticClass: "homepage__partners-wrapper"
  }, [_c("Partner")], 1), _c("section", {
    staticClass: "homepage__appointment-wrapper"
  }, [_c("Appointment2", {
    attrs: {
      productId: _vm.productId
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };